import {styled} from "@mui/material/styles"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Container = styled("div")`
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
    color: ${({theme}) => theme.uxfabric.text.primary};
    display: flex;
    flex-direction: column;
    border-radius: 0.25rem;
    width: 20rem;
    @media (max-width: ${breakpoints.values.md - 1}px) {
        width: 18rem;
    }
`

export const ActionWrapper = styled("div")`
    margin: 0.625rem auto;
    display: flex;
    margin: 0rem 0rem;
    padding: 1rem 1rem;
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    border-top: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    && > div,
    && > a {
        width: 18rem;
        @media (max-width: ${breakpoints.values.md - 1}px) {
            width: 16rem;
        }
        height: 2.25rem;
        margin: 0;
        flex-shrink: 1;
    }
`
